import { render, staticRenderFns } from "./SidebarPc.vue?vue&type=template&id=47047f92&"
import script from "./SidebarPc.vue?vue&type=script&lang=ts&"
export * from "./SidebarPc.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports